import { c as _c } from "react/compiler-runtime";
import { FormSelect, RadioGroup } from '@systemeio/ui';
import EditActionWrapper from 'modules/automation-rules/actions/components/edit-actions/components/edit-action-wrapper';
import { EditActionItemInterface } from 'modules/automation-rules/actions/components/edit-actions/types/edit-action-item-interface';
import { AutomationRuleActionsEnum } from 'modules/automation-rules/actions/enums/action-enum';
import { ActionCourseBundleEditInterface } from 'modules/automation-rules/actions/types/automation-rule-actions-edit-interface';
import { getDataFromObj } from 'modules/automation-rules/utils/get-filter-data';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { getCourseBundleAccessTypeDataOptions } from 'modules/courses/bundles/course-bundle/enums/access-type-enum';
interface ActionCourseBundleItemProps extends EditActionItemInterface<ActionCourseBundleEditInterface> {}
const ActionCourseBundleItem = t0 => {
  const $ = _c(17);
  const {
    actions,
    action,
    errors,
    setRules,
    onDelete,
    idx
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== idx || $[1] !== onDelete) {
    t1 = () => onDelete(idx);
    $[0] = idx;
    $[1] = onDelete;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== action.courseBundle || $[4] !== action.enrollmentAccessType || $[5] !== action.id || $[6] !== action.type || $[7] !== actions || $[8] !== errors.automationActions || $[9] !== idx || $[10] !== setRules || $[11] !== t) {
    t2 = t3 => {
      const {
        data,
        onOpen,
        renderActionLabel
      } = t3;
      return <><FormSelect onOpen={onOpen} label={renderActionLabel({
          label: t("dashboard.course_bundle.title_one")
        })} placeholder={t("dashboard.automation_rule.choose_course_bundle")} value={action.courseBundle?.id} data={data.courseBundleData} staticData={getDataFromObj(action.courseBundle ?? {})} onChange={data_0 => setRules(prev => ({
          ...prev,
          actions: actions.map((el, i) => {
            if (idx === i) {
              return {
                ...el,
                courseBundle: {
                  id: data_0
                }
              };
            } else {
              return el;
            }
          })
        }))} error={errors.automationActions[action.id]?.courseBundle?.join("")} />{action.type === AutomationRuleActionsEnum.enroll_in_course_bundle && <RadioGroup options={getCourseBundleAccessTypeDataOptions(t)} selected={action.enrollmentAccessType} onChange={data_1 => setRules(prev_0 => ({
          ...prev_0,
          actions: actions.map((el_0, i_0) => {
            if (idx === i_0) {
              return {
                ...el_0,
                enrollmentAccessType: data_1
              };
            } else {
              return el_0;
            }
          })
        }))} />}</>;
    };
    $[3] = action.courseBundle;
    $[4] = action.enrollmentAccessType;
    $[5] = action.id;
    $[6] = action.type;
    $[7] = actions;
    $[8] = errors.automationActions;
    $[9] = idx;
    $[10] = setRules;
    $[11] = t;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  let t3;
  if ($[13] !== action.type || $[14] !== t1 || $[15] !== t2) {
    t3 = <EditActionWrapper slug={action.type} onDelete={t1}>{t2}</EditActionWrapper>;
    $[13] = action.type;
    $[14] = t1;
    $[15] = t2;
    $[16] = t3;
  } else {
    t3 = $[16];
  }
  return t3;
};
export default ActionCourseBundleItem;